export const AlertSetupModel = {
    name: "",
    description: "",
    movement: false,
    not_send: false,
    battery: false,
    temperature: false,
    signal: false,
    out_range: false,
    levels: false,
    params: {
        force: 1,
        days: 3,
        level: 10,
        temperature: 70,
        signal: -140,
        range: 100,
        filling_mark: 75,
        vacuum_mark: 25,
        email_to_filler: false,
        email_on_emptying: false,
    },
};
export const AlertParamsModel = {
    name: "",
    description: "",
    active: false,
    type: "",
    params: [],
};
export const AlertParamModel = {
    type: "",
    label: "",
    required: false,
    value: "",
};
export const AlertSetupsParamsEmpty = [
    {
        name: "Sudden movement",
        attr: "movement",
        description: "Warning of the occurrence of a sudden movement in a container",
        params: {
            force: {
                type: "number",
                label: "G-force",
                required: true,
                value: 1,
                min: 0,
                max: 2,
                step: 0.1,
            },
        },
        type: "sm",
    },
    {
        name: "Non-shipment alert",
        attr: "not_send",
        description:
            "Warning of containers that have not sent measurements for some time",
        params: {
            days: {
                type: "number",
                label: "days",
                required: true,
                value: 3,
                min: 1,
                max: 7,
                step: 1,
            },
        },
        type: "na",
    },
    {
        name: "Low Battery",
        attr: "battery",
        description: "Alarm in case of low battery of the device",
        params: {
            level: {
                type: "number",
                label: "level",
                required: true,
                value: 10,
                min: 10,
                max: 100,
                step: 1,
            },
        },
        type: "lb",
    },
    {
        name: "High temperature",
        attr: "temperature",
        description: "Alarm for exceeding the temperature limit of the device",
        params: {
            temperature: {
                type: "number",
                label: "temperature",
                required: true,
                value: 70,
                min: 10,
                max: 150,
                step: 1,
            },
        },
        type: "ht",
    },
    {
        name: "GSM signal alert",
        attr: "signal",
        description: "Warning of GSM signal level lower than specified",
        params: {
            signal: {
                type: "number",
                label: "signal",
                required: true,
                value: -140,
                min: -140,
                max: -50,
                step: 1,
            },
        },
        type: "ga",
    },
    {
        name: "Out of range",
        attr: "out_range",
        description: "Warning of container in external location",
        params: {
            range: {
                type: "number",
                label: "movement",
                required: true,
                value: 100,
                min: 1,
                max: 150,
                step: 1,
            },
        },
        type: "or",
    },
    {
        name: "Collection level",
        attr: "level",
        description:
            "Alarm for exceeding the level set as collection and subsequent emptying",
        params: {
            filling_mark: {
                type: "number",
                label: "filling mark",
                required: true,
                value: 75,
                min: 0,
                max: 100,
                step: 1,
            },
            vacuum_mark: {
                type: "number",
                label: "vacuum mark",
                required: true,
                value: 25,
                min: 0,
                max: 100,
                step: 1,
            },
            email_to_filler: {
                type: "checkbox",
                label: "email to filler",
                required: true,
                value: false,
            },
            email_on_emptying: {
                type: "checkbox",
                label: "email on emptying",
                required: true,
                value: false,
            },
        },
        type: "pl",
    },
];
export const AlertParams = {
    sm: {
        force: {
            required: true,
            value: 1,
            min: 0,
            max: 2,
            step: 0.1,
        },
    },
    na: {
        days: {
            required: true,
            value: 3,
            min: 1,
            max: 7,
            step: 1,
        },
    },
    lb: {
        level: {
            required: true,
            value: 10,
            min: 10,
            max: 100,
            step: 1,
        },
    },
    ht: {
        temperature: {
            required: true,
            value: 70,
            min: 10,
            max: 150,
            step: 1,
        },
    },
    ga: {
        signal: {
            required: true,
            value: -140,
            min: -140,
            max: -50,
            step: 1,
        },
    },
    or: {
        range: {
            required: true,
            value: 100,
            min: 1,
            max: 150,
            step: 1,
        },
    },
    pl: {
        filling_mark: {
            required: true,
            value: 75,
            min: 0,
            max: 100,
            step: 1,
        },
        vacuum_mark: {
            required: true,
            value: 25,
            min: 0,
            max: 100,
            step: 1,
        },
    },
};
export const AlertDeviceConfigModel = {
    name: "",
    description: "",
    movement: false,
    not_send: false,
    battery: false,
    temperature: false,
    signal: false,
    out_range: false,
    levels: false,
    model: "",
    params: {
        force: 1,
        days: 3,
        level: 10,
        temperature: 70,
        signal: -140,
        range: 100,
        filling_mark: 75,
        vacuum_mark: 25,
        email_to_filler: false,
        email_on_emptying: false,
    },
};
